import { FC, ReactNode } from 'react';

import { cn } from '@/utils/tailwind';

type SettingsModalSectionProps = {
  title?: string;
  subtitle?: string;
  children?: ReactNode;
};

const SettingsModalSection: FC<SettingsModalSectionProps> = ({
  title,
  subtitle,
  children,
}) => {
  if (!title && !subtitle) {
    return children;
  }

  return (
    <div className="flex flex-col gap-5">
      <div className={cn('flex flex-row items-start justify-between')}>
        <div className="flex flex-col items-start">
          <div className="text-md font-bold">{title}</div>
          <div className="text-sm text-tertiary">{subtitle}</div>
        </div>
      </div>
      {children}
    </div>
  );
};

export default SettingsModalSection;
